export default "__VITE_ASSET__M5M2zy3u__"